import { 
    SET_ACTIVE_PROJECT_LIST,
    SET_LOADING,
    SET_SELECTED_PROJECT,
    SET_SELECTED_PROJECT_JOBS,
    SET_SELECTED_ROLES
} from "../../actions/project/types";

const INITIAL_STATE = {
    loading: false,
    selectedRoleList: [],
    activeProjectList: [],
    selectedProjectJobs: [],
    selectedProject: null,
}

const ProjectReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        case SET_SELECTED_ROLES: {
            return {
                ...state,
                selectedRoleList: action.payload
            }
        }
        case SET_ACTIVE_PROJECT_LIST: {
            return getActiveAuditionList(state, action)
        }
        case SET_SELECTED_PROJECT_JOBS: {
            return {
                ...state,
                selectedProjectJobs: action.payload
            }
        }
        case SET_SELECTED_PROJECT: {
            return {
                ...state,
                selectedProject: action.payload
            }
        }
        default: {
            return state;
        }
    }
}

const getActiveAuditionList = (state, action) => {
    let tempSelectedProject = state.selectedProject;

    if (tempSelectedProject) {
        tempSelectedProject = action.payload.find((item) => item?.projectId === tempSelectedProject?.projectId);
    }

    return {
        ...state,
        activeProjectList: action.payload,
        selectedProject: tempSelectedProject
    }
}

export default ProjectReducer;